module.exports = __webpack_public_path__ + "static/media/04.Bhaskar Kogga Kamath with Puppets.1d9c1554.jpg";